import { render, staticRenderFns } from "./CustomMenu.vue?vue&type=template&id=2ca3b109&"
import script from "./CustomMenu.vue?vue&type=script&lang=ts&"
export * from "./CustomMenu.vue?vue&type=script&lang=ts&"
import style0 from "./CustomMenu.vue?vue&type=style&index=0&id=2ca3b109&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports